import React from 'react';
import { CtaButton } from './CtaButton';
interface SectionCtaProps {
  label: string;
  sub?: string;
  variant?: 'primary' | 'light';
}

/**
 * The transformational CTA repeated at the end of every section.
 */
export function SectionCta({
  label,
  sub,
  variant = 'primary'
}: SectionCtaProps) {
  return <div className="mx-auto mt-9 w-full max-w-md" data-id="element-59" data-mp="3nbqi758cm81o">
      <CtaButton label={label} sub={sub ?? 'Instant access · One-time payment · 7-day guarantee'} size="md" variant={variant} data-id="element-60" data-mp="3necshcmmj1nl" />
    </div>;
}